/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Cenorion Tenant Edge API (DEV)
 * Live API Gateway routes, documented from backend contracts/rest.
 * OpenAPI spec version: live
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetTenantAppIconsParams,
  ProblemDetails,
  TenantAppIconsPutResponse,
  TenantAppIconsRequest,
  TenantAppIconsResponse,
  TenantBrandingRequest,
  TenantBrandingResponse
} from '../../models';

import { apiMutator } from '../../../http/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * The icons the tenant holds for the packages asked about, read from the bundle in force, with the `assets_version` they were read from.
 * @summary Read the icons of some apps from the tenant's asset bundle
 */
export const getTenantAppIcons = (
    params: GetTenantAppIconsParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<TenantAppIconsResponse>(
      {url: `/v1/tenants/me/app-icons`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetTenantAppIconsQueryKey = (params?: GetTenantAppIconsParams,) => {
    return [
    `/v1/tenants/me/app-icons`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetTenantAppIconsQueryOptions = <TData = Awaited<ReturnType<typeof getTenantAppIcons>>, TError = ProblemDetails>(params: GetTenantAppIconsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantAppIcons>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTenantAppIconsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenantAppIcons>>> = ({ signal }) => getTenantAppIcons(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTenantAppIcons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTenantAppIconsQueryResult = NonNullable<Awaited<ReturnType<typeof getTenantAppIcons>>>
export type GetTenantAppIconsQueryError = ProblemDetails


export function useGetTenantAppIcons<TData = Awaited<ReturnType<typeof getTenantAppIcons>>, TError = ProblemDetails>(
 params: GetTenantAppIconsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantAppIcons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantAppIcons>>,
          TError,
          Awaited<ReturnType<typeof getTenantAppIcons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantAppIcons<TData = Awaited<ReturnType<typeof getTenantAppIcons>>, TError = ProblemDetails>(
 params: GetTenantAppIconsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantAppIcons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantAppIcons>>,
          TError,
          Awaited<ReturnType<typeof getTenantAppIcons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantAppIcons<TData = Awaited<ReturnType<typeof getTenantAppIcons>>, TError = ProblemDetails>(
 params: GetTenantAppIconsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantAppIcons>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read the icons of some apps from the tenant's asset bundle
 */

export function useGetTenantAppIcons<TData = Awaited<ReturnType<typeof getTenantAppIcons>>, TError = ProblemDetails>(
 params: GetTenantAppIconsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantAppIcons>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTenantAppIconsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Merges the icons into the tenant's current asset bundle and moves `assets_version` on by exactly one: the way a branding publish does, except that only app icons change and every other entry.
 * @summary Add, replace or remove app icons in the tenant's asset bundle
 */
export const putTenantAppIcons = (
    tenantAppIconsRequest: TenantAppIconsRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<TenantAppIconsPutResponse>(
      {url: `/v1/tenants/me/app-icons`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: tenantAppIconsRequest, signal
    },
      options);
    }




export const getPutTenantAppIconsMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTenantAppIcons>>, TError,{data: TenantAppIconsRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof putTenantAppIcons>>, TError,{data: TenantAppIconsRequest}, TContext> => {

const mutationKey = ['putTenantAppIcons'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTenantAppIcons>>, {data: TenantAppIconsRequest}> = (props) => {
          const {data} = props ?? {};

          return  putTenantAppIcons(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutTenantAppIconsMutationResult = NonNullable<Awaited<ReturnType<typeof putTenantAppIcons>>>
    export type PutTenantAppIconsMutationBody = TenantAppIconsRequest
    export type PutTenantAppIconsMutationError = ProblemDetails

    /**
 * @summary Add, replace or remove app icons in the tenant's asset bundle
 */
export const usePutTenantAppIcons = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTenantAppIcons>>, TError,{data: TenantAppIconsRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTenantAppIcons>>,
        TError,
        {data: TenantAppIconsRequest},
        TContext
      > => {
      return useMutation(getPutTenantAppIconsMutationOptions(options), queryClient);
    }
    /**
 * The display name, both logos, theme, colours, currency and font the tenant's devices currently render, with `assets_version`.
 * @summary Read the branding set in force
 */
export const getTenantBranding = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<TenantBrandingResponse>(
      {url: `/v1/tenants/me/branding`, method: 'GET', signal
    },
      options);
    }




export const getGetTenantBrandingQueryKey = () => {
    return [
    `/v1/tenants/me/branding`
    ] as const;
    }


export const getGetTenantBrandingQueryOptions = <TData = Awaited<ReturnType<typeof getTenantBranding>>, TError = ProblemDetails>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantBranding>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTenantBrandingQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTenantBranding>>> = ({ signal }) => getTenantBranding(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTenantBranding>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTenantBrandingQueryResult = NonNullable<Awaited<ReturnType<typeof getTenantBranding>>>
export type GetTenantBrandingQueryError = ProblemDetails


export function useGetTenantBranding<TData = Awaited<ReturnType<typeof getTenantBranding>>, TError = ProblemDetails>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantBranding>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantBranding>>,
          TError,
          Awaited<ReturnType<typeof getTenantBranding>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantBranding<TData = Awaited<ReturnType<typeof getTenantBranding>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantBranding>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantBranding>>,
          TError,
          Awaited<ReturnType<typeof getTenantBranding>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTenantBranding<TData = Awaited<ReturnType<typeof getTenantBranding>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantBranding>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Read the branding set in force
 */

export function useGetTenantBranding<TData = Awaited<ReturnType<typeof getTenantBranding>>, TError = ProblemDetails>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTenantBranding>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTenantBrandingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Validates the set, merges it into the tenant's current asset bundle (only the branding part changes: everything else in the bundle is carried over untouched).
 * @summary Publish a new branding set
 */
export const putTenantBranding = (
    tenantBrandingRequest: TenantBrandingRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<TenantBrandingResponse>(
      {url: `/v1/tenants/me/branding`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: tenantBrandingRequest, signal
    },
      options);
    }




export const getPutTenantBrandingMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTenantBranding>>, TError,{data: TenantBrandingRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof putTenantBranding>>, TError,{data: TenantBrandingRequest}, TContext> => {

const mutationKey = ['putTenantBranding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putTenantBranding>>, {data: TenantBrandingRequest}> = (props) => {
          const {data} = props ?? {};

          return  putTenantBranding(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutTenantBrandingMutationResult = NonNullable<Awaited<ReturnType<typeof putTenantBranding>>>
    export type PutTenantBrandingMutationBody = TenantBrandingRequest
    export type PutTenantBrandingMutationError = ProblemDetails

    /**
 * @summary Publish a new branding set
 */
export const usePutTenantBranding = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putTenantBranding>>, TError,{data: TenantBrandingRequest}, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putTenantBranding>>,
        TError,
        {data: TenantBrandingRequest},
        TContext
      > => {
      return useMutation(getPutTenantBrandingMutationOptions(options), queryClient);
    }
